import { Injectable } from '@angular/core';
import {  Http , Response} from '@angular/http';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Utils } from './../shared/utils';

import 'rxjs/add/operator/toPromise';

import { Upload } from './../uploads/upload';


@Injectable()
export class UploadService {

  private uploadUrl = '/envios';

  constructor(private http: Http, private _flashMessagesService: FlashMessagesService, private utils: Utils) { }

  getUploads(params?: any): Promise<Upload[]> {
    return this.http.get(this.uploadUrl, {search:this.utils.buildParams(params)})
                .toPromise()
                .then(response => response.json().dados as any[])
                .catch((error) => this.handleError(error));
  }

  getUpload(id: number, params?: any): Promise<Upload> {
    let url: string  = this.uploadUrl + '/' + id;
 
    return this.http.get(url,{search:this.utils.buildParams(params) } )
                .toPromise()
                .then(response => response.json().dados as Upload )
                .catch((error) => this.handleError(error));
  }

  deleteUpload(upload: Upload): Promise<Response>{
    let url: string = this.uploadUrl + '/' + upload.id ;
    return this.http
               .delete(url)
               .toPromise()
               .then(response => this.handleSuccess(response.json()))
               .catch((error) => this.handleError(error));
  }

  upload(upload: Upload): Promise<Upload[]>{
    return this.http
                .post(this.uploadUrl, this.utils.buildFormData(upload))
                .toPromise()
                .then(response => response.json().dados as Upload[])
                .catch((error) => this.handleError(error));
  }
  agendar(upload: Upload): Promise<Response>{
    let url: string = this.uploadUrl + '/agendar/' + upload.id ;
    return this.http
                .get(url)
                .toPromise()
                .then(response =>this.handleSuccess(response.json()))
                .catch((error) => this.handleError(error));
  }
  private handleSuccess(resp: any): Promise<any> {
    this.utils.flashMessage(resp.msg, 'success');
    //this._flashMessagesService.show(resp.msg, { cssClass: 'card alert-success', timeout: 5000 });
    return resp;
  }

  private handleError(error: any): Promise<any> {
     switch (error.status) {
      case 500:
        this.utils.flashMessage('Ocorreu error no servidor, entre em contato com o administrador.', 'danger');
        //this._flashMessagesService.show("Ocorreu error no servidor, entre em contato com o administrador.", { cssClass: 'card alert-danger', timeout: 5000 });
        break;
      case 403:

        this.utils.flashMessage(error.json().msg, 'warning');
        //this._flashMessagesService.show(error.json().msg, { cssClass: 'card alert-warning', timeout: 5000 });
        break;
      default:
      this.utils.flashMessage("Ocorreu um error, tente novamente mais tarde.", 'danger');
        //this._flashMessagesService.show("Ocorreu um error, tente novamente mais tarde.", { cssClass: 'card alert-danger', timeout: 5000 });
    }
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// ./src/app/uploads/upload.service.ts